import React, { useState } from "react";
import PropTypes from "prop-types";
import _isEmpty from "lodash/isEmpty";
import {
  Divider,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  FormControlLabel,
  Link,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useStyles from "./styles";

const Notifications = ({ notifications, handleTeamUpdate, handleTwilioUpdate }) => {
  const classes = useStyles();
  const [twilio, setTwilio] = useState(
    notifications.twilio_settings || {
      enabled: false,
      sid: "",
      token: "",
      phone: "",
    }
  );

  const handleTwilio = (e) => {
    const updated = {
      ...twilio,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    };
    setTwilio(updated);
    handleTwilioUpdate(updated);
  };

  const handleToggle = (checked, employee_id) => {
    const index = notifications.team_members.findIndex((x) => x.employee_id === employee_id);
    notifications.team_members[index].enabled = checked;
    handleTeamUpdate(notifications.team_members);
  };

  return (
    <>
      <ExpansionPanel elevation={1} defaultExpanded={!notifications.twilio_settings}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="twilio-settings" id="twilio-settings">
          <FormControlLabel
            className={classes.small}
            control={<Switch size="small" name="enabled" checked={twilio.enabled} onChange={handleTwilio} />}
          />
          <Link
            href="https://www.twilio.com/try-twilio"
            target="_blank"
            rel="noopener noreferrer"
            variant="body1"
            underline="none"
            color="primary"
          >
            Twilio Settings
          </Link>
          <Typography variant="caption" className={classes.caption} color="primary">
            {!notifications.twilio_settings ? "(required)" : "(completed)"}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.block}>
          <TextField
            name="sid"
            placeholder="Account Sid"
            value={twilio.sid}
            className={classes.input}
            onChange={handleTwilio}
          />
          <TextField
            required
            name="phone"
            type="tel"
            placeholder="Phone"
            value={twilio.phone}
            className={classes.input}
            onChange={handleTwilio}
          />
          <TextField
            name="token"
            placeholder="Auth Token"
            type="password"
            autoComplete="password"
            value={twilio.token}
            fullWidth
            className={classes.input}
            onChange={handleTwilio}
          />
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <List>
        {_isEmpty(notifications.team_members) ? (
          <ListItemText className={classes.centerContent} secondary={"Employees not found in Square."} />
        ) : (
          notifications.team_members
            .filter((x) => x.is_active)
            .map((member) => <TeamRow key={member.employee_id} member={member} handleToggle={handleToggle} />)
        )}
      </List>
    </>
  );
};

const TeamRow = ({ member, handleToggle }) => {
  const { employee_id, display_name, phone_number, enabled } = member;
  const [value, setValue] = useState(enabled);

  return (
    <>
      <ListItem>
        <ListItemText id={employee_id} primary={display_name} secondary={phone_number || "(Phone not in Square)"} />
        <ListItemSecondaryAction>
          <Switch
            edge="end"
            onChange={(e) => {
              setValue(e.target.checked);
              handleToggle(e.target.checked, employee_id);
            }}
            checked={value}
            inputProps={{ "aria-labelledby": "sms-notifications" }}
          />
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </>
  );
};

Notifications.propTypes = {
  notifications: PropTypes.shape({
    team_members: PropTypes.array,
    twilio_settings: PropTypes.shape({
      enabled: PropTypes.bool,
      sid: PropTypes.string,
      token: PropTypes.string,
      phone: PropTypes.string,
    }),
  }),
  handleTeamUpdate: PropTypes.func.isRequired,
  handleTwilioUpdate: PropTypes.func.isRequired,
};

Notifications.defaultProps = {
  notifications: {
    team_members: [],
    twilio_settings: { enabled: false, sid: "", token: "", phone: "" },
  },
};

export default Notifications;
